<template>
	<ProcessCreatePage>
		<Header :title="title"></Header>

		<Footer @backButtonClick="$emit('previous', $event)" :is-skippable="false" :is-back-button="true" :is-continue-button="false" />
	</ProcessCreatePage>
</template>

<script>
import Header from '@/components/damagecases/Header';
import Footer from '@/components/damagecases/Footer';
import ProcessRepository from '@/api/repositories/ProcessRepository';
import LoadingSpinner from '@/mixins/LoadingSpinner';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ProcessCreateOrderFinish',
	components: { ProcessCreatePage, Footer, Header },
	mixins: [LoadingSpinner],
	data() {
		return {
			isLoading: true,
			isError: false,
		};
	},
	computed: {
		title() {
			const prefix = this.$t('store_new_order_documentation');
			if (this.isLoading) return prefix + this.$t('new_comprehensive_wait');
			else if (this.isError) return prefix + this.$t('new_comprehensive_error');
			else return prefix + this.$t('new_comprehensive_success');
		},
	},
	mounted() {
		this.setLoadingStatus(true);
		new ProcessRepository()
			.storeProcessOrderDocumentation(this.$store.getters.getProcessCreateOrderDocumentation)
			.then(response => {
				this.setLoadingStatus(false);
				this.$swal({
					title: this.$t('general.success').toString(),
					text: this.$t('stored_order_documentation').toString(),
					icon: 'success',
					showCancelButton: false,
					confirmButtonText: this.$t('general.next').toString(),
				}).then(() => {
					this.$store.commit('clearProcessCreateOrderDocumentation');
					this.$store.commit('setConfirmLeaving', false);

					this.$router.push({
						name: 'management.process.edit',
						params: { processId: response.data.data.id, customer: this.$route.query.customer_id },
					});
				});
			})
			.catch(() => {
				this.setLoadingStatus(false);
				this.isError = true;
				this.$swal(this.$t('general.error').toString(), this.$t('stored_order_documentation_error').toString(), 'error');
			})
			.finally(() => (this.isLoading = false));
	},
};
</script>

<style scoped></style>
